class MobileThumbnailSlider {

    constructor() {
        this.initMobileSlider();
    }

    initMobileSlider() {
        this.thumbnailSlider = document.querySelector('.mobile-thumbnail-slider');
        if (!this.thumbnailSlider) return;

        this.slideshow = document.querySelector('[ref="slideshow"]');
        this.thumbnailList = this.thumbnailSlider.querySelector('.mobile-thumbnail-list');
        this.thumbnailButtons = this.thumbnailSlider.querySelectorAll('.mobile-thumbnail-item');
        this.prevButton = this.thumbnailSlider.querySelector('[data-thumbnail-nav="prev"]');
        this.nextButton = this.thumbnailSlider.querySelector('[data-thumbnail-nav="next"]');

        //get size of thumbnail, all thumbnails have the same size so just take the first one
        this.buttonWidth = this.thumbnailButtons[0].getAttribute('data-thumbnail-width');

        this.setupResizeObserver();
        this.updateNavigationButtons();
        this.bindEvents();
    }

    bindEvents() {
        // Handle thumbnail clicks
        this.thumbnailButtons.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.goToSlide(index);
            });
        });

        // Handle navigation button clicks
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => {
                this.scrollLeft('prev');
            });
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.scrollRight('next');
            });
        }

        // Update navigation buttons on scroll
        if (this.thumbnailList) {
            this.thumbnailList.addEventListener('scroll', () => {
                this.updateNavigationButtons();
            });
        }

        this.slideshow.addEventListener('slideshow:select', (event) => {
            const slideIndex = event.detail?.index;
            if (typeof slideIndex === 'number') {
                this.updateActiveThumbnail(slideIndex);
                this.scrollThumbnailIntoView(slideIndex);
            }
        });
    }

    scrollLeft() {

        this.thumbnailList.scrollTo({
            left: this.thumbnailList.scrollLeft - 2 * this.buttonWidth,
            behavior: 'smooth'
        });
    }

    scrollRight() {

        this.thumbnailList.scrollTo({
            left: this.thumbnailList.scrollLeft + 2 * this.buttonWidth,
            behavior: 'smooth'
        });
    }

    goToSlide(index) {
        if (!this.slideshow) {
            return;
        }

        this.slideshow.select(index);

        this.updateActiveThumbnail(index);
    }

    updateActiveThumbnail(index) {
        // Remove active state from all thumbnails
        this.thumbnailButtons.forEach(button => {
            button.removeAttribute('aria-pressed');
        });

        // Add active state to the current thumbnail
        if (this.thumbnailButtons[index]) {
            this.thumbnailButtons[index].setAttribute('aria-pressed', 'true');
        }
    }

    scrollThumbnailIntoView(index) {
        const thumbnail = this.thumbnailButtons[index];
        if (!thumbnail) return;

        const listRect = this.thumbnailList.getBoundingClientRect();
        const thumbnailRect = thumbnail.getBoundingClientRect();
        const listScroll = this.thumbnailList.scrollLeft;
        const listWidth = listRect.width;
        // Calculate the center position of the list
        const listCenter = listWidth / 2;

        // Calculate the position of the thumbnail relative to the list
        const thumbnailLeft = index * this.buttonWidth;
        const thumbnailCenter = thumbnailLeft + (this.buttonWidth / 2);

        // Calculate the scroll position needed to center the thumbnail
        const targetScroll = thumbnailCenter - listCenter;

        // Check if thumbnail is not fully visible
        this.thumbnailList.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    }

    setupResizeObserver() {
        if (!this.thumbnailList) return;

        this.resizeObserver = new ResizeObserver(() => {
            this.updateNavigationButtons();
        });

        this.resizeObserver.observe(this.thumbnailList);
    }

    updateNavigationButtons() {
        if (!this.thumbnailList || !this.prevButton || !this.nextButton) return;

        const { scrollWidth, clientWidth, scrollLeft } = this.thumbnailList;
        const maxScroll = scrollWidth - clientWidth;

        // Update disabled states
        this.prevButton.disabled = scrollLeft <= 2;
        this.nextButton.disabled = scrollLeft >= maxScroll - 1;
    }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.mobile-thumbnail-slider');
    if (slider && !slider.initialized) {
        new MobileThumbnailSlider();
        slider.initialized = true;
    }
});